module.exports = __webpack_public_path__ + "static/media/AB_W1_6.b69e5ed3.jpg";